import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Col, Row } from 'react-bootstrap';
import CLabel from '../../../../components/Common/CLabel';
import { useGetContratoDI } from '../../../../hooks/component/sPay/useOfContractParties';
import { useDispatch, useSelector } from 'react-redux';
import { action_updateContractPartieSidePanelIsOpen } from '../../../../reducers/actions/PAY/actions';
import { __MessageTypes, enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG } from '../../../../common/Dictionaries';
import JqxNumberInput from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxnumberinput';
import { isNullUndefinedOrEmptyOrNegative, showMessage } from '../../../../common/Helpers';
import FinalizePartieAdvaiceDialog from '../Dialogs/FinalizePartieAdvaiceDialog';
import MessageBoxInfoComplex from '../../../../components/Common/Message/MessageBoxInfoComplex';
import { getValidateCierrePartidas, setCierrePartidas, setContratoDI } from '../../../../services/sPay/partie.service';
import CValidator from '../../../../components/Common/CValidator';

const SidePanelFinalizeParties = ({elementId, contractCode}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const numberValidDecimals = 10;

    const {
        _contractPartieSidePanelsConfig: contractPartieSidePanelsConfig,
    } = useSelector((state) => state.contractPartiesState);

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isFormDisabled, setIsFormDisabled] = useState(false);
    const [listComponentAmount, setListComponentAmount] = useState(null);

    
    
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [objIsValidForm, setObjIsValidForm] = useState({
        isInValidIncentivos            : false,
        isInValidDevolucionRetenciones : false,
        isInValidOtrosIncrementos      : false,
        isInValidPenalizaciones        : false,
        isInValidRetenciones           : false,
        isInValidOtrasDeducciones      : false,
    });

    useGetContratoDI(elementId, listComponentAmount, setListComponentAmount)

    const onDismissPanel = () => {
        showMessage(setMessageConfig, false, null, null)
        dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_FINISH, false))

        if (isFormDisabled) {
            window.location.href = window.location.href;
        }
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const isInvalidForm = () => {
        let isInvalid = false;

        listComponentAmount.l_result.forEach(component => {
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrNegative(component.monto) : isInvalid;
        });

        return isInvalid;
    };

    const onPreFinalizeParties = async () => {
        if (!isInvalidForm()) {
            await getValidateCierrePartidas(elementId).then((response) => {
                if (response.data.succeeded) {
                    if (response.data.data.result) {
                        setIsDialogOpen(true);
                    }
                    else {
                        let messageString = '';
                        response.data.data.l_messages.forEach(message => {
                            messageString += message + "<br>";
                        });
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, messageString)
                    }
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-finalizepartieserror'))
                }
            }).catch((ex) => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-someerrorsdetected'))
        }
    };

    const onFinalizeParties = async (responseFlag) => {
        if (responseFlag) {
            if (!isInvalidForm()) {
                await setContratoDI(elementId, listComponentAmount).then(async (response) => {
                    if (response.data.succeeded) {
                        if (response.data.data) {
                            await setCierrePartidas(elementId).then((responseCierre) => {
                                if (responseCierre.data.succeeded) {
                                    if (responseCierre.data.data.result) {
                                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t(responseCierre.data.message))
                                        setIsFormDisabled(true)
            
                                        //Dispatch para cierre de partidas de ser necesario.
                                        //Revisar con Pablo. Que se debe leer para no volver a llegar a este dialogo.
                                    }
                                    else {
                                        let messageString = '';
                                        responseCierre.data.data.l_messages.forEach(message => {
                                            messageString += message + "<br>";
                                        });
                                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, messageString)
                                    }
                                }
                                else {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('Se ha producido un problema al cerrar las partidas.'))
                                }
                            }).catch((ex) => {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                            });
                        }
                        else {
                            let messageString = '';
                            response.data.data.l_messages.forEach(message => {
                                messageString += message + "<br>";
                            });
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, messageString)
                        }
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('Se ha producido un problema al cerrar las partidas.'))
                    }
                }).catch((ex) => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-someerrorsdetected'))
            }
        }
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBoxInfoComplex
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                            inputParam_ShowClose={true}
                            inputParam_TranslateText={true}
                        />
                    </Col>
                    {
                        !isFormDisabled &&
                        <Col xl={12}>
                            <PrimaryButton className='me-1' onClick={ onPreFinalizeParties }>{ t('data-lang-btn-save') }</PrimaryButton>
                            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                        </Col>
                    }
                </Row>
    }

    const onChangeObjString = (value, fieldName, isInvalidPropertyField, id) => {
        const isInValidValue = isNullUndefinedOrEmptyOrNegative(value);

        for (let index = 0; index < listComponentAmount.l_result.length; index++) {
            if (listComponentAmount.l_result[index].id === id) {
                listComponentAmount.l_result[index].monto = value;
                break;
            }
        }

        setListComponentAmount(listComponentAmount);
        setObjIsValidForm(prevState => ({ ...prevState, [isInvalidPropertyField]: isInValidValue }));
    };

    return (
        <div>
            <Panel
                isOpen={ contractPartieSidePanelsConfig.isPanelFinishPartieOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-finalizeparties') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <fieldset disabled={isFormDisabled}>
                    <Row>
                        {
                            listComponentAmount && listComponentAmount.l_result.filter(x => x.tipo === 1).map((component, index) => {
                                return  <Col xs={12} className={`my-3 ${(index === 0 ? 'mt-5' : '')}`}>
                                            <Row>
                                                <Col xl={6}>
                                                    <CLabel labelText={ component.nombre } />
                                                </Col>
                                                <Col xl={6}>
                                                    <JqxNumberInput
                                                        height={25}
                                                        width={"100%"}
                                                        decimalDigits={numberValidDecimals}
                                                        digits={12}
                                                        symbolPosition={'right'}
                                                        value={component.monto}
                                                        groupSeparator= ','
                                                        decimalSeparator= '.'
                                                        onChange={(event) => onChangeObjString(event.args.value, 'incentivos', 'isInValidIncentivos', component.id)}
                                                    />
                                                    <CValidator isInValid={objIsValidForm.isInValidIncentivos} inValidText={t('data-lang-msg-nonnegativevalue')} /> 
                                                </Col>
                                            </Row>
                                        </Col>
                            })
                        }
                        {
                            listComponentAmount && listComponentAmount.l_result.filter(x => x.tipo === 2).map(component => {
                                return  <Col xs={12} className='my-3'>
                                            <Row>
                                                <Col xl={6}>
                                                    <CLabel labelText={ component.nombre } />
                                                </Col>
                                                <Col xl={6}>
                                                    <JqxNumberInput
                                                        height={25}
                                                        width={"100%"}
                                                        decimalDigits={numberValidDecimals}
                                                        digits={12}
                                                        symbolPosition={'right'}
                                                        value={component.monto}
                                                        groupSeparator= ','
                                                        decimalSeparator= '.'
                                                        onChange={(event) => onChangeObjString(event.args.value, 'incentivos', 'isInValidIncentivos', component.id)}
                                                    />
                                                    <CValidator isInValid={objIsValidForm.isInValidIncentivos} inValidText={t('data-lang-msg-nonnegativevalue')} /> 
                                                </Col>
                                            </Row>
                                        </Col>
                            })
                        }
                    </Row>
                </fieldset>
                {
                    isDialogOpen &&
                    <FinalizePartieAdvaiceDialog
                        isModalOpen={isDialogOpen}
                        setIsModalOpen={setIsDialogOpen}
                        setterAction={onFinalizeParties}
                        contractCode={contractCode}
                    />
                }
            </Panel>
        </div>
    );
};

SidePanelFinalizeParties.propTypes = {
};

export default SidePanelFinalizeParties;